export default "__VITE_ASSET__81f779c0__"